import { cart_drawer } from './cart_drawer.js';

(() => {

const body = document.body;

let winW = window.innerWidth;
let winH = window.innerHeight;
window.addEventListener('resize', function(){
	winW = window.innerWidth;
	winH = window.innerHeight;
});

var ofstY = 30;
function anchorLink(){
  const anchor = document.querySelectorAll('.anchor');
  anchor.forEach((el) => {
    el.addEventListener('click', (e) => {
      const href = e.currentTarget.getAttribute('href');
      const url = new URL(href, location.origin);
      const isHashOnly = href && href.startsWith('#');
      const isSamePage = isHashOnly || (url.pathname === location.pathname);
      if (isSamePage && url.hash) {
        e.preventDefault();
        body.classList.remove('navopen');
        gsap.to(window, { duration:0.6, scrollTo:{y:url.hash, autoKill:false, offsetY:ofstY}, ease:'power2'});
      }
    });
  });
}


function modalFunc() {
  const modalBtns = document.querySelectorAll('.modalbtn');
  modalBtns.forEach((btn) => {
    btn.addEventListener('click', function () {
      if(body.classList.contains('modal-open')){
        body.classList.remove('modal-open');
        const modals = document.querySelectorAll('.modal');
        modals.forEach((modal) => {
          modal.classList.remove('is-open');
        });
        return;
      }
      const modalId = btn.getAttribute('data-modal');
      const modal = document.getElementById(modalId);
      if (modal) {
        if (modal.classList.contains('is-open')) {
          modal.classList.remove('is-open');
          body.classList.remove('modal-open');
        } else {
          modal.classList.add('is-open');
          body.classList.add('modal-open');
        }
      }
    });
  });

  const modals = document.querySelectorAll('.modal');
  modals.forEach((modal) => {
    modal.addEventListener('click', function (e) {
      if (e.target === modal) {
        modal.classList.remove('is-open');
        body.classList.remove('modal-open');
      }
    });
  });
}


function navInit() {
  const nav_anchor = () => {
    const navlinks = document.querySelectorAll('#main_nav a');
    navlinks.forEach((link) => {
      if (link.hash) {
        link.classList.add('anchor');
        link.addEventListener('click', (e) => {
          body.classList.remove('modal-open');
          const modals = document.querySelectorAll('.modal');
          modals.forEach((modal) => {
            modal.classList.remove('is-open');
          });
        });
      }
    });
  }
  nav_anchor();
}


function defaultImageSlide(slider, pagination){
  const swiper = new Swiper(slider, {
    effect: "fade",
    fadeEffect: {
      crossFade: true
    },
    slidesPerView: 1,
    speed: 300,
    spaceBetween: 0,
    loop: true,
    keyboard: {
      enabled: false,
    },
    pagination: {
      el: pagination,
      type: "bullets",
      clickable: true,
      renderBullet: function (index, className) {
        return '<span class="' + className + '">' + (index + 1) + "</span>";
      },
    },
  });
  slider.querySelectorAll('img').forEach((img) => {
    img.addEventListener('click', (e) => {
      swiper.slideNext();
    });
  });
  
  return swiper;
}


function variantImageSwitch() {
  if (!window.productVariants) return;
  const productForm = document.querySelector('#product_single form.product_form');
  if (!productForm) return;
  
  const swiper = document.querySelector('.item_slider')?.swiper;
  const optionInputs = productForm.querySelectorAll('input[type="radio"][name^="options"]');
  const priceElement = document.querySelector('#product_single .title_set .price');
  const variantIdInput = productForm.querySelector('input[name="id"]');
    
  const updateVariant = () => {
    const selectedOptions = [];
    optionInputs.forEach(input => {
      if (input.checked) {
        selectedOptions.push(input.value);
      }
    });    
    const matchedVariant = window.productVariants.find(variant => {
      return variant.options.every((opt, idx) => opt === selectedOptions[idx]);
    });
    if (matchedVariant) {
      // Update hidden variant ID
      if (variantIdInput) {
        variantIdInput.value = matchedVariant.id;
      }
      
      // Update price
      if (priceElement) {
        let priceHTML = '';
        if (matchedVariant.compare_at_price) {
          priceHTML = `<s>${matchedVariant.compare_at_price}</s><br>\n`;
        }
        priceHTML += `${matchedVariant.price}`;
        priceElement.innerHTML = priceHTML;
      }
      
      // Update image (only if swiper exists)
      if (swiper && window.productImages && matchedVariant.featured_image) {
        const imageIndex = window.productImages.findIndex(img => img === matchedVariant.featured_image);
        if (imageIndex !== -1) {
          swiper.slideToLoop(imageIndex, 300);
        }
      } else if (window.productImages && matchedVariant.featured_image) {
        const imageIndex = window.productImages.findIndex(img => img === matchedVariant.featured_image);
        if (imageIndex !== -1) {
          const slides = document.querySelectorAll('.item_slider .swiper-slide');
          if (slides[imageIndex]) {
            slides[imageIndex].scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        }
      }
    }
  };
  
  optionInputs.forEach(input => {
    input.addEventListener('change', updateVariant);
  });
}



function imageSlide(){
  const slider = document.querySelector('.item_slider');
  const pagination = document.querySelector('.swiper-pagination');
  defaultImageSlide(slider, pagination);
}


function muitlblockSlide(){
  const swipers = document.querySelectorAll('.muitlblock_slider');
  swipers.forEach((slider_item) => {
    const slider = slider_item;
    const pagination = slider_item.parentElement.nextElementSibling;
    defaultImageSlide(slider, pagination);
  });
}


function recommendSlide(){
  const gap = getComputedStyle(document.documentElement).getPropertyValue('--gap');
  const gapInPx = parseFloat(gap) * 10;

  const recommendSwiper = document.querySelectorAll('.recommend_swiper');
  recommendSwiper.forEach((swiper) => {
    const swiperInstance = new Swiper(swiper, {
      slidesPerView: 2,
      speed: 300,
      spaceBetween: 15,
      keyboard: {
        enabled: false,
      },
      navigation: {
        nextEl: '.sw_next',
        prevEl: '.sw_prev',
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
          spaceBetween: 40,
        },
        1024: {
          slidesPerView: 5,
          spaceBetween: 40,
        },
      },
    });
  });
}


// function mouseCursor(){
//   const cursor = document.getElementById("cursor");
//   const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
//   if (!canHover) {
//     cursor.style.display = 'none';
//     return;
//   }

//   gsap.set(cursor, {xPercent: -50, yPercent: -50});
//   let xSetter = gsap.quickTo(cursor, "x", {duration: 0.4, ease: "power4"});
//   let ySetter = gsap.quickTo(cursor, "y", {duration: 0.4, ease: "power4"});
//   cursor.style.display = 'block';

//   window.addEventListener("mousemove", e => {
//     xSetter(e.clientX);
//     ySetter(e.clientY);
//   });
//   //Click events
//   const clickableElements = ['a', 'button', '.modalbtn', '.swiper-pagination-bullet', '.option-group label'];
//   clickableElements.forEach((selector) => {
//     const elements = document.querySelectorAll(selector);
//     elements.forEach((el) => {
//       el.addEventListener('mouseenter', () => {
//         gsap.to(cursor, {duration: 0.2, scale: 1, ease: "power2.out"});
//       });
//       el.addEventListener('mouseleave', () => {
//         gsap.to(cursor, {duration: 0.2, scale: 0.6, ease: "power2.out"});
//       });
//     });
//   });
//   // Cart Drawer
//   const cartArea = document.querySelectorAll('#CartDrawer, #cart');
//   cartArea.forEach((area) => {
//     area.addEventListener('mouseenter', () => {
//       cursor.classList.add('wh');
//     });
//     area.addEventListener('mouseleave', () => {
//       cursor.classList.remove('wh');
//     });
//   });
//   // Form elements
//   const formElements = document.querySelectorAll('input, textarea, select');
//   formElements.forEach((el) => {
//     const hide = () => gsap.to(cursor, {duration: 0.2, scale: 0, ease: "power2.out"});
//     const show = () => gsap.to(cursor, {duration: 0.2, scale: 1, ease: "power2.out"});
//     el.addEventListener('focus', hide);
//     el.addEventListener('blur', show);
//     el.addEventListener('mouseenter', hide);
//     el.addEventListener('mouseleave', () => {
//       if (document.activeElement === el) return;
//       show();
//     });
//   });

//   window.addEventListener('mouseout', (e) => {
//     if (e.relatedTarget == null) {
//       cursor.style.display = 'none';
//     }
//   });
//   window.addEventListener('mouseover', (e) => {
//     if (e.relatedTarget == null) {
//       cursor.style.display = 'block';}
//   });
// }

function expandFunc() {
  const expand = (parent, state) => {
    if(state){
      parent.classList.add('open');
    }else{
      parent.classList.remove('open');
    }
    const exc = parent.querySelector('.exc');
    gsap.utils.toArray(exc).forEach(ex => {
      gsap.to(ex,{
        height: (!state) ? 0 : "auto",
        duration:0.3,
        ease: "power2.inOut",
        onComplete: () => {
          ScrollTrigger.refresh();
        }
      });
    });
  }
  const expand_event = (e) => {
    let parent = e.target.closest('.ex');
    const result = parent.classList.contains('open');
    if (result) {
      expand(parent, false);
    }else{
      expand(parent, true);
    }
  };
  gsap.utils.toArray('.exbtn').forEach(exbtn => {
    let parent = exbtn.closest('.ex');
    expand(parent, false);
    exbtn.removeEventListener('click',expand_event);
    exbtn.addEventListener('click',expand_event);
  });
}


// Shopify Forms Customization
function setShopifyFormsColor() {
  document.querySelectorAll('shopify-forms-embed').forEach(form => {
    if (form.shadowRoot && form.shadowRoot.host) {
      form.shadowRoot.host.style.setProperty('--form-text-color', '#00884d');
      form.shadowRoot.host.style.setProperty('--form-placeholder-color', '#00884d');
      form.shadowRoot.host.style.setProperty('--form-field-border-radius', '0px');
      form.shadowRoot.host.style.setProperty('--form-field-border', '0 0 0 1px #00884d');
      form.shadowRoot.host.style.setProperty('--form-background-color', 'none');
      form.shadowRoot.host.style.setProperty('--button-border-radius', '0px');
      form.shadowRoot.host.style.setProperty('--button-background-color', 'none');
      
      const paths = form.shadowRoot.querySelectorAll('svg path');
      paths.forEach(path => {
        path.setAttribute('fill', '#00884d');
      });
      const submit = form.shadowRoot.querySelector('button[type="submit"]');
      submit.style.border = '1px solid #00884d';
    }
  });
}
document.addEventListener('DOMContentLoaded', setShopifyFormsColor);
//フォームの追加・再描画にも対応
const observer = new MutationObserver(setShopifyFormsColor);
observer.observe(document.body, { childList: true, subtree: true });


function wrapJapaneseText(selector) {
  const elements = document.querySelectorAll(selector);
  // Include hiragana, katakana, kanji, full-width symbols, and full-width numbers
  const japaneseReg = /[\u3040-\u30FF\u4E00-\u9FFF\uFF01-\uFF60０-９]+/g;
  
  elements.forEach(el => {
    // Skip if already processed
    if (el.classList && el.classList.contains('jp-processed')) return;
    
    const walker = document.createTreeWalker(
      el,
      NodeFilter.SHOW_TEXT,
      null,
      false
    );
    
    const nodesToReplace = [];
    let node;
    
    while (node = walker.nextNode()) {
      // Skip if parent is script, style, or already wrapped
      const parent = node.parentNode;
      if (parent.tagName === 'SCRIPT' || 
          parent.tagName === 'STYLE' || 
          parent.classList?.contains('jp_txt')) {
        continue;
      }
      
      // Reset regex for each test
      japaneseReg.lastIndex = 0;
      if (japaneseReg.test(node.textContent)) {
        nodesToReplace.push(node);
      }
    }
    
    nodesToReplace.forEach(textNode => {
      const text = textNode.textContent;
      const fragment = document.createDocumentFragment();
      let lastIndex = 0;
      
      // Reset regex before replace
      japaneseReg.lastIndex = 0;
      const matches = [];
      let match;
      
      while ((match = japaneseReg.exec(text)) !== null) {
        matches.push({ text: match[0], index: match.index });
      }
      
      matches.forEach((m, i) => {
        // Add text before match
        if (m.index > lastIndex) {
          fragment.appendChild(document.createTextNode(text.slice(lastIndex, m.index)));
        }
        
        // Add wrapped Japanese text
        const span = document.createElement('span');
        span.className = 'jp_txt';
        span.textContent = m.text;
        fragment.appendChild(span);
        
        lastIndex = m.index + m.text.length;
      });
      
      // Add remaining text
      if (lastIndex < text.length) {
        fragment.appendChild(document.createTextNode(text.slice(lastIndex)));
      }
      
      textNode.parentNode.replaceChild(fragment, textNode);
    });
    
    if (el.classList) {
      el.classList.add('jp-processed');
    }
  });
}



function initialize(){
	cart_drawer();
  modalFunc();
  navInit();
	anchorLink();
  expandFunc();
  
  // Sliders must be initialized before wrapJapaneseText
  if( document.getElementById('product_single') ){
    imageSlide();
    // Also initialize variant switching for products without images
    setTimeout(() => {
      variantImageSwitch();
    }, 100);
  }
  if( document.getElementById('blog_single') ){
    imageSlide();
  }
  if( document.getElementById('muitlblock_page') ){
    muitlblockSlide();
  }
  if( document.querySelectorAll('.recommend_swiper') ){
    recommendSlide();
  }
  
  // Run wrapJapaneseText after all other initializations
  wrapJapaneseText('.MainContent, #footer');
}

window.addEventListener('load', function () {
	initialize();
	body.classList.add('ready');
});

})();